module.exports = __webpack_public_path__ + "static/media/icon_carpool.34580fae.svg";